export default "/_next/static/fonts/Graphik-Regular-303ba2a54367d2fb1fe1b4c1176c2e46.woff2";